import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import authGuard from '@/router/guards/auth-guard'
import LayoutFull from '@/layouts/full/LayoutFull.vue'

export default [
  {
    path: '/user',
    component: LayoutFull,
    beforeEnter: multiGuard([checkTokenGuard, authGuard]),
    children: [
      {
        path: 'notifications',
        name: 'owner:notifications',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/notifications/NotificationsTable.vue'),
      },
      {
        path: 'invoices',
        name: 'owner:invoices',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/invoices/InvoicesTable.vue'),
      },
      {
        path: 'telegram',
        name: 'owner:telegram',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/telegram/TelegramIntegration.vue'),
      },
    ],
  },
]
